import React, { useState, useEffect } from "react";

function ContactUsCTR() {
    const companyphone = "+971559215470";
    const companywhatsappLink = `https://wa.me/${companyphone}`;

    const [formData, setFormData] = useState({
        name: "",
        email: "",
        message: "",
    });
    const [status, setStatus] = useState("");
    const [isSubmitting, setIsSubmitting] = useState(false);

    useEffect(() => {
        if (status) {
            const timer = setTimeout(() => setStatus(""), 8000);
            return () => clearTimeout(timer);
        }
    }, [status]);

    const handleChange = (e) => {
        setFormData({ ...formData, [e.target.name]: e.target.value });
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmitting(true);
        setStatus("");

        try {
            const response = await fetch("https://demo.bonvoytourism.com/bonvoytourismbackend/api/contactus", {
            // const response = await fetch("http://localhost:3000/bonvoytourismbackend/api/contactus", {
                method: "POST",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify(formData),
            });

            const result = await response.json();

            if (response.ok) {
                setStatus("Message sent successfully! We'll get back to you soon.");
                setFormData({ name: "", email: "", message: "" });
            } else {
                setStatus(result.error || "Failed to send message. Please try again.");
            }
        } catch (error) {
            setStatus("An error occurred. Please try again later.");
        } finally {
            setIsSubmitting(false);
        }
    };

    return (
        <div>
            <div className="mt-12 md:mt-22 mb-6 md:mb-10">
                <h3 className="text-[20px] md:text-[24px] lg:text-[30px] text-[#666] font-semibold mb-4">
                    Any questions? Feel free to ask us!
                </h3>
                <p className="text-[15px] text-[#8C8C8C] max-w-[730px] mb-4">
                    Leave your guidebooks at home and dive into the local cultures that make each destination so special. We’ll connect you with our exclusive experiences.
                </p>
                <p className="text-[15px] text-[#8C8C8C] max-w-[730px]">
                    Your Customer Care team is just a phone call away at
                </p>
            </div>
            {/* Form Section */}
            <div className="flex flex-col md:flex-row gap-12 md:gap-30 justify-between">

                {/* Contact Info Section */}
                <div className="space-y-4 flex-1">
                    <h3 className="text-[18px] font-medium text-[#606060]">Contact Information</h3>
                    <div className="w-full h-[2px] bg-[#ebebeb]" />
                    <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
                        <p>PHONE:</p>
                        <a
                            href={`tel:${companyphone}`}
                            className="hover:text-[#ff9219] transition"
                        >
                            {companyphone}
                        </a>
                    </div>
                    <div className="w-full h-[2px] bg-[#ebebeb]" />
                    <div className="w-full h-[2px] bg-[#ebebeb]" />
                    <div className="text-[13px] font-medium text-[#606060] flex gap-[12px] items-center">
                        <p>WHATSAPP:</p>
                        <a
                            href={companywhatsappLink}
                            target="_blank"
                            rel="noopener noreferrer"
                            className="hover:text-[#ff9219] transition"
                        >
                            Chat on WhatsApp
                        </a>

                    </div>
                </div>
                <div className="flex-[3]">
                    <form className="w-full text-[13px] space-y-4" onSubmit={handleSubmit}>
                        <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
                            <img src="/images/contact/user.png" alt="user" width={16} height={16} />
                            <input
                                className="w-full outline-none"
                                type="text"
                                name="name"
                                value={formData.name}
                                onChange={handleChange}
                                placeholder="Your Name"
                                required
                            />
                        </div>

                        <div className="flex gap-[12px] items-center w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
                            <img src="/images/contact/email.png" alt="email" width={16} height={16} />
                            <input
                                className="w-full outline-none"
                                type="email"
                                name="email"
                                value={formData.email}
                                onChange={handleChange}
                                placeholder="Your Email"
                                required
                            />
                        </div>

                        <div className="flex gap-[12px] items-start w-full border-2 border-[#f1f1f1] rounded-[4px] text-[#969595] px-[15px] py-[10px]">
                            <img src="/images/contact/chat.png" alt="chat" width={16} height={16} />
                            <textarea
                                className="w-full outline-none resize-none"
                                name="message"
                                value={formData.message}
                                onChange={handleChange}
                                placeholder="Your Message"
                                rows={8}
                                required
                            />
                        </div>

                        <button
                            type="submit"
                            className="bg-[#ff9219] text-white py-[10px] px-[50px] rounded-[4px] font-medium hover:bg-slate-400 transition-all duration-300 ease-in-out"
                            disabled={isSubmitting}
                        >
                            {isSubmitting ? "Sending..." : "Send Now"}
                        </button>
                    </form>

                    {status && (
                        <p
                            className={`text-[13px] text-white mt-4 py-[10px] px-[50px] text-center rounded-[4px] ${status.includes("successfully") ? "bg-[#ff9219]" : "bg-red-600"
                                }`}
                        >
                            {status}
                        </p>
                    )}
                </div>
            </div>
        </div>
    );
}

export default ContactUsCTR;
